module.exports = __webpack_public_path__ + "img/pallets_business_active.9939e443.png";